import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: linear-gradient(to bottom left, #137CEA, #0A3E75);

  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`

export const Logo = styled.img`
  max-width: 60%;
  padding: 40px;
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`

export const LogoMobile = styled.img`
  max-width: 70%;
  padding: 0;
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  border-radius: 5px;
  padding: 40px 20px 20px;

  @media only screen and (max-width: 768px) {
    height: calc(100vh - 150px);
    padding: 0 20px 20px;
  }

  @media only screen and (min-width: 769px) and (max-width: 1024px) {

  }

  @media only screen and (min-width: 1367px) {
    padding: 20px;
    &::before {
      width: 200px;
      height: 200px;
      top: -110px;
    } 
  }
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const ControlsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;